import { TableFieldModel } from '@/model/TableList'

export const FilterField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyName',
    fieldName: '公司名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号'
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'customerCompanyContactName',
  //   fieldName: '联系人'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '业务品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号'
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'serial',
  //   fieldName: '序列号'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'marketCost',
  //   fieldName: '市场成本',
  //   textAlign: 'right',
  //   isMoney: true,
  //   width: 100
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'outCost',
  //   fieldName: '外包成本',
  //   textAlign: 'right',
  //   isMoney: true,
  //   width: 100
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号'
  },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'salesManId',
    fieldName: '业务代表',
    options: 'salesManOption',
    focus: 'handleSalesManFocus'
  }
  // {
  //   componentType: 'el-select',
  //   componentName: '输入框',
  //   fieldKey: 'type',
  //   fieldName: '业务类型',
  //   options: 'businessTypeOption',
  //   visible: (data) => {
  //     const { pageType, type } = data
  //     return !pageType || type
  //   }
  // },
  // {
  //   componentType: 'el-select',
  //   componentName: '输入框',
  //   fieldKey: 'urgentId',
  //   fieldName: '紧急程度',
  //   options: 'urgentOption'
  // },
  // {
  //   componentType: 'el-select',
  //   componentName: '输入框',
  //   fieldKey: 'status',
  //   fieldName: '业务状态',
  //   visible: (data) => {
  //     const { showStateFilter } = data
  //     return showStateFilter
  //   },
  //   options: 'statusOption'
  // },
  // {
  //   componentType: 'el-select',
  //   componentName: '输入框',
  //   fieldKey: 'engineerId',
  //   fieldName: '工程师',
  //   focus: 'handleEngineerFocus',
  //   options: 'engineerOption'
  // }
]
